import { useEffect, useState } from "react";
import { LogOut, User, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { memberStore } from "@/utils/unlockStore";
import { memberChangePassword, apiErrorMessage } from "@/services/api";

const inputCls = "w-full rounded-lg border border-[color:var(--border-gold)] bg-white px-3 py-2 text-sm text-[#111] outline-none focus:border-[color:var(--accent-crimson)]";

function ChangePwDialog({ open, onOpenChange }) {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const m = await memberChangePassword(f);
      memberStore.set(m);
      toast.success("Password changed ✅");
      setF({ current_password: "", new_password: "" });
      onOpenChange(false);
    } catch (e) { toast.error(apiErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="member-changepw-dialog" className="max-w-sm border-[color:var(--border-gold)] bg-[color:var(--bg-card)] text-[color:var(--text-primary)]">
        <DialogHeader>
          <DialogTitle className="font-display">Password badlein</DialogTitle>
          <DialogDescription>Enter your old and new password</DialogDescription>
        </DialogHeader>
        <input data-testid="member-current-pw" type="password" placeholder="Current password" className={inputCls} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
        <input data-testid="member-new-pw" type="password" placeholder="New password (min 6 characters)" className={inputCls} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
        <button type="button" data-testid="member-changepw-save" onClick={save} disabled={busy || !f.current_password || f.new_password.length < 6}
          className="btn-gold flex w-full items-center justify-center gap-1.5 rounded-lg py-2.5 text-sm font-bold disabled:opacity-50">
          <KeyRound className="h-4 w-4" /> {busy ? "..." : "Save"}
        </button>
      </DialogContent>
    </Dialog>
  );
}

export function MemberChip() {
  const [m, setM] = useState(() => memberStore.get());
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setM(memberStore.get());
    window.addEventListener("bgr-member", on);
    return () => window.removeEventListener("bgr-member", on);
  }, []);
  if (!m) return null;
  return (
    <>
    <span data-testid="member-chip" className="inline-flex items-center gap-1 rounded-full border border-[color:var(--border-gold)] bg-[color:var(--bg-card)] py-1 pl-2 pr-1 text-xs font-bold text-[color:var(--text-primary)]">
      <button type="button" data-testid="member-chip-name" onClick={() => setOpen(true)} title="Password badlein" className="inline-flex items-center gap-1">
        <User className="h-3.5 w-3.5" /> <span className="hidden max-w-[70px] truncate sm:inline">{m.name}</span>
      </button>
      <button type="button" data-testid="member-logout" aria-label="Logout" onClick={() => { memberStore.clear(); toast.success("Logged out"); }}
        className="grid h-6 w-6 place-items-center rounded-full text-red-500 transition-colors hover:bg-red-500/10">
        <LogOut className="h-3.5 w-3.5" />
      </button>
      <ChangePwDialog open={open} onOpenChange={setOpen} />
    </span>
    </>
  );
}
